import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';
import GuestPage from './GuestPage';
import HomePage from './HomePage'; // <-- ✅ Import the new HomePage
import { auth } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

export default function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} /> {/* ✅ Home page route */}
        <Route
          path="/admin"
          element={
            user ? <AdminPanel onLogout={handleLogout} /> : <Navigate to="/admin-login" replace />
          }
        />
        <Route
          path="/admin-login"
          element={
            user ? <Navigate to="/admin" replace /> : <AdminLogin onLogin={() => {}} />
          }
        />
        <Route path="/guest/:code" element={<GuestPage />} />
        <Route path="*" element={<p>404 Not Found</p>} />
      </Routes>
    </Router>
  );
}
